export const BABEL_IGNORE_RE = Object.freeze(
  /[\\/]node_modules[\\/](?!.*[\\/]esnext[\\/])/
);
